const es = {
  7000001: "Red",
  7000002: "Estrategia de red",
  7000003: "Spot de Red",
  7000004: "Oscilador",
  7000005: "Comprar Bajo Vender Alto",
  7000006: "Arbitraje cíclico",
  7000007: "Herramienta",
  7000008: "Operaciones de copia de futuros",
  7000009: "Copia de operaciones con un clic gana dinero juntos",

  target_8: "Cuenta de estrategia",
};
export default es;
